import { Injectable, inject } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import { MatDateRangeSelectionStrategy, DateRange } from "@angular/material/datepicker";

@Injectable()
export class WeekSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  private _dateAdapter = inject<DateAdapter<D>>(DateAdapter<D>);

  selectionFinished(date: D | null): DateRange<D> {
    return this._createWeekRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createWeekRange(activeDate);
  }

  private _createWeekRange(date: D | null): DateRange<D> {
    if (date) {
      const dow = this._dateAdapter.getDayOfWeek(date);
      const start = this._dateAdapter.addCalendarDays(date, -dow);
      const end = this._dateAdapter.addCalendarDays(date, 7-dow-1);
      return new DateRange<D>(start, end);
    }

    return new DateRange<D>(null, null);
  }
}